import { render, staticRenderFns } from "./AwardScoreReport.vue?vue&type=template&id=4129e8a5"
import script from "./AwardScoreReport.vue?vue&type=script&lang=js"
export * from "./AwardScoreReport.vue?vue&type=script&lang=js"
import style0 from "./AwardScoreReport.vue?vue&type=style&index=0&id=4129e8a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports